import React from 'react';
import PropTypes from 'prop-types';

// app
import { LinkView } from './Link.view';
import * as utils from 'utils';

Link.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.object,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.oneOf(['primary', 'secondary', 'neutral']),
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  nestedClasses: PropTypes.shape({
    root: PropTypes.string,
    link: PropTypes.string,
  }),
};

Link.defaultProps = {
  color: 'neutral',
  nestedClasses: {},
  iconPosition: 'left',
};

export default function Link({ text, disabled, handleClick, ...rest }) {
  const onClick = (event) => {
    if (!disabled && utils.generic.isFunction(handleClick)) {
      handleClick(event);
    }
  };

  // abort
  if (!text) return null;

  return <LinkView text={text} disabled={disabled} onClick={onClick} {...rest} />;
}
